import { useEffect, useState } from 'react';

const useAccessCheckLoading = (delay = 1000) => {
  const [accessCheckLoading, setAccessCheckLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAccessCheckLoading(false);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return accessCheckLoading;
};

export default useAccessCheckLoading;
